if (!customElements.get('td-testimonial')) {
  class TDTestimonial extends HTMLElement {
    static SELECTORS = {
      slider: '[data-td-testimonial-slider]',
      slide: '[data-td-testimonial-slide]',
      quickAdd: '[data-td-testimonial-quick-add]',
    };

    constructor() {
      super();
      this.emblaApi = null;
      this.editorSelectedBlockId = null;

      this.handleEmblaInit = this.handleEmblaInit.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      this.handleQuickAdd = this.handleQuickAdd.bind(this);
    }

    connectedCallback() {
      this.sliderElement = this.querySelector(TDTestimonial.SELECTORS.slider);
      this.slideElements = Array.from(this.querySelectorAll(TDTestimonial.SELECTORS.slide));

      if (!(this.sliderElement instanceof HTMLElement)) {
        return;
      }

      this.sliderElement.addEventListener('embla:init', this.handleEmblaInit);
      this.addEventListener('click', this.handleQuickAdd);

      if (this.sliderElement.emblaApi) {
        this.emblaApi = this.sliderElement.emblaApi;
      }

      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
    }

    disconnectedCallback() {
      this.sliderElement?.removeEventListener('embla:init', this.handleEmblaInit);
      this.removeEventListener('click', this.handleQuickAdd);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      this.emblaApi = null;
      this.editorSelectedBlockId = null;
    }

    handleEmblaInit(event) {
      this.emblaApi = event?.detail?.api || this.sliderElement?.emblaApi || null;
    }

    handleQuickAdd(event) {
      if (!(event.target instanceof Element)) {
        return;
      }

      const trigger = event.target.closest(TDTestimonial.SELECTORS.quickAdd);
      if (!(trigger instanceof HTMLElement) || !this.contains(trigger)) {
        return;
      }

      const source = document.getElementById(trigger.dataset.tdQuickAddSourceId);
      const modal = document.querySelector('td-quick-add-modal');
      if (!(source instanceof HTMLElement) || !modal || typeof modal.open !== 'function') {
        return;
      }

      event.preventDefault();
      modal.open(source);
    }

    handleBlockSelect(event) {
      const blockId = event.detail?.blockId;
      const slide = this.getSlideByBlockId(blockId);
      if (!(slide instanceof HTMLElement)) {
        return;
      }

      this.editorSelectedBlockId = blockId;
      this.pauseAutoplay();

      if (!this.emblaApi) {
        this.emblaApi = this.sliderElement?.emblaApi || null;
      }

      if (!this.emblaApi) {
        return;
      }

      const slideIndex = this.slideElements.indexOf(slide);
      if (slideIndex >= 0) {
        this.emblaApi.scrollTo(slideIndex, true);
      }
    }

    handleBlockDeselect(event) {
      const blockId = event.detail?.blockId;
      if (this.editorSelectedBlockId && blockId && this.editorSelectedBlockId !== blockId) {
        return;
      }

      this.editorSelectedBlockId = null;
      this.resumeAutoplay();
    }

    getSlideByBlockId(blockId) {
      if (!blockId) {
        return null;
      }

      const escapedBlockId = typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(blockId) : blockId;
      return this.querySelector(`[data-td-block-id="${escapedBlockId}"]`);
    }

    pauseAutoplay() {
      if (typeof this.sliderElement?.pauseAutoplay === 'function') {
        this.sliderElement.pauseAutoplay();
      }
    }

    resumeAutoplay() {
      if (typeof this.sliderElement?.resumeAutoplay === 'function') {
        this.sliderElement.resumeAutoplay();
      }
    }
  }

  customElements.define('td-testimonial', TDTestimonial);
}
